import { Grid, Snackbar, CircularProgress } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useEffect, useRef, useState } from "react";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import { useAppServices } from "hook/services";
import env from "config";
import { useAgencyInfo } from "context/agency";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useKnowledgeBase } from "context/knowledgebaseContext";
import { FaQuestionCircle } from "react-icons/fa";
import { getSubdomain } from "tldts";
import PrimaryButton from "../../../../../components/PrimaryButton";

function Domain({
  selectedTheme,
  buttonLoading,
  open,
  setOpen,
  handleRefresh,
  setDomainMessageDisconnect,
  domainMessageDisconnect,
}) {
  const inputData = selectedTheme?.theme_data?.domain;
  const SERVER_IP = env.SERVER_IP;
  const BACKEND_API = env.API_URL;

  const [domainUpdate, setdomainUpdate] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [dnsShow, setDnsShow] = useState(false);
  const [domainErrorMessage, setDomainErrorMessage] = useState("");
  const [domainMessage, setDomainMessage] = useState("");
  const [startListening, setStartListening] = useState(false);
  const [domainLoading, setDomainLoading] = useState(false);
  const [showRootFallbackDns, setShowRootFallbackDns] = useState(false);
  const [domainText, setDomaintext] = useState("");
  const [domainReconnectError, setDomainReconnectError] = useState("");
  const messageTimerRef = useRef(null);
  const rootFallbackTimerRef = useRef(null);
  const { knowledgeBase, loading } = useKnowledgeBase();
  const previewResponseRef = useRef(null);

  const Service = useAppServices();
  const [agency, Update] = useAgencyInfo();
  const [agencyDomain, setAgencyDomain] = useState(inputData?.domain?.replace(/^www\./i, "") || "");
  const [domain, setDomain] = useState(inputData?.domain?.replace(/^www\./i, "") || "");

  const cleanDomain = domain?.replace(/^www\./i, "").trim();
  // Uses the Public Suffix List (via tldts) instead of counting dots, so
  // multi-label public suffixes like .co.uk/.com.au are classified correctly
  // (e.g. "supportlocaltas.com.au" is a root domain, not "supportlocaltas.com").
  const subdomain = (cleanDomain && getSubdomain(cleanDomain)) || "@";

  // ✅ Timeline steps
  // const [domainSteps, setDomainSteps] = useState([
  //   { key: "dns_checking", label: "Checking DNS", status: "pending" },
  //   { key: "dns_valid", label: "DNS Validated", status: "pending" },
  //   { key: "configuring", label: "Configuring Domain", status: "pending" },
  //   { key: "cert_generated", label: "Generating SSL Certificate", status: "pending" },
  //   { key: "nginx_configured", label: "Configuring Nginx", status: "pending" },
  //   { key: "enable_https", label: "Enabled Https", status: "pending" },
  //   { key: "active", label: "Domain Activated", status: "pending" },
  //   { key: "dns_invalid", label: "Dns Records Invalid", status: "pending" },
  // ]);

  const [domainSteps, setDomainSteps] = useState([
    {
      key: "dns_checking",
      label: "Checking DNS Configuration",
      status: "pending",
    },
    {
      key: "dns_valid",
      label: "DNS Verified Successfully",
      status: "pending",
    },
    {
      key: "configuring",
      label: "Creating Domain Configuration",
      status: "pending",
    },
    {
      key: "ssl_generating",
      label: "Generating SSL Certificate",
      status: "pending",
    },
    {
      key: "active",
      label: "Domain Connected Successfully",
      status: "pending",
    },
    {
      key: "dns_invalid",
      label: "Invalid DNS Configuration",
      status: "pending",
    },
    {
      key: "config_failed",
      label: "Failed To Create Configuration",
      status: "pending",
    },
    {
      key: "reload_failed",
      label: "Failed To Reload Server",
      status: "pending",
    },
    {
      key: "failed",
      label: "Domain Connection Failed",
      status: "pending",
    },
  ]);

  // ✅ Update step status
  const updateStepStatus = (currentKey) => {
    setDomainSteps((prev) =>
      prev.map((step) => {
        if (step.key === currentKey) {
          return { ...step, status: "loading" };
        }
        if (step.status === "loading") {
          return { ...step, status: "completed" };
        }
        return step;
      })
    );
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDomaintext("");
    setDomainReconnectError("");
    setDomainLoading(true);

    if (!cleanDomain && cleanDomain === "") {
      setDomainErrorMessage("Please Enter domain,Domain is required");
      setDomainLoading(false);
      return 0;
    }

    if (cleanDomain && cleanDomain !== "") {
      setDnsShow(true);
      setStartListening(true);
    }

    const payload = {
      domain: cleanDomain,
      agency_id: agency?._id,
      theme_id: agency?.theme_id,
    };

    try {
      const { response } = await Service.themes.DomainConnection({ payload });

      if (response?.success) {
        setResponseMessage(response?.message);
        // Update({
        //   ...response.data,
        //   domain: response.domain,
        // });
        previewResponseRef.current = {
          ...response.data,
          domain: response?.domain,
        };
        if (!response?.domain || response?.domain === "") {
          setDomainLoading(false);
          setDomainMessage("Domain removed successfully");
        }
        setAgencyDomain(response?.domain);
      } else {
        setDomainErrorMessage(response?.message || "");
        setStartListening(false);
      }
    } catch (err) {
      setDomainErrorMessage("Server error occurred");
    }
  };

  const Disconnect = async () => {
    setDomainLoading(true);
    const payload = {
      domain: "",
      agency_id: agency?._id,
      theme_id: agency?.theme_id,
    };
    const { response } = await Service.themes.DomainConnection({ payload });

    if (response?.success) {
      setDomainMessageDisconnect("Domain removed successfully");

      await handleRefresh();
      Update(response?.data);
      setAgencyDomain("");
      setDomain("");
    }

    setDomainLoading(false);
  };

  useEffect(() => {
    if (!domainMessage && !domainErrorMessage) return;

    messageTimerRef.current = setTimeout(() => {
      setDomainMessage("");
      setDomainErrorMessage("");
    }, 3000);

    return () => clearTimeout(messageTimerRef.current);
  }, [domainMessage, domainErrorMessage]);

  useEffect(() => {
    if (!dnsShow) {
      setShowRootFallbackDns(false);
      clearTimeout(rootFallbackTimerRef.current);
      return;
    }

    rootFallbackTimerRef.current = setTimeout(() => {
      setShowRootFallbackDns(true);
    }, 20000);

    return () => clearTimeout(rootFallbackTimerRef.current);
  }, [dnsShow]);

  const showReconnectError = () => {
    setTimeout(() => {
      setDomainReconnectError("Domain is not connected, please reconnect the domain");
    }, 3000);
  };

  useEffect(() => {
    if (!agency?._id || !startListening) return;

    const eventSource = new EventSource(`${BACKEND_API}/v1/themes/domain-status/${agency._id}`);

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);

      updateStepStatus(data.status);

      // ✅ FINAL STATES
      if (data.status === "active") {
        setDomainLoading(false);
        setDnsShow(false);
        setStartListening(false);

        if (previewResponseRef.current) {
          Update(previewResponseRef.current);
          previewResponseRef.current = null;
        }

        setDomainMessage("Domain connected successfully");
        eventSource.close();
        setDomainSteps((prev) =>
          prev.map((step) => ({
            ...step,
            status: "pending",
          }))
        );
      }

      if (data.status === "failed") {
        setDomainLoading(false);
        setStartListening(false);
        setDomainErrorMessage("Failed to connect domain");
        setDomaintext("Reconnect domain");
        showReconnectError();
        setAgencyDomain("");
        eventSource.close();
        setDomainSteps((prev) =>
          prev.map((step) => ({
            ...step,
            status: "pending",
          }))
        );
      }
      if (data.status === "dns_invalid") {
        setDomainLoading(false);
        setStartListening(false);
        setDomainErrorMessage("Dns Record is invalid");
        setDomaintext("Reconnect domain");
        showReconnectError();
        setAgencyDomain("");
        eventSource.close();
        setDomainSteps((prev) =>
          prev.map((step) => ({
            ...step,
            status: "pending",
          }))
        );
      }
      // if (data.status === "https_failed") {
      //   setDomainLoading(false);
      //   setStartListening(false);
      //   setDomainErrorMessage("Failed to assign SSL");
      //   eventSource.close();
      //   setDomainSteps((prev) =>
      //     prev.map((step) => ({
      //       ...step,
      //       status: "pending",
      //     }))
      //   );
      // }
      if (data.status === "config_failed" || data.status === "reload_failed") {
        setDomainLoading(false);

        setStartListening(false);

        setDomainErrorMessage("Failed to connect domain");

        setDomaintext("Reconnect domain");
        showReconnectError();
        setAgencyDomain("");

        eventSource.close();

        setDomainSteps((prev) =>
          prev.map((step) => ({
            ...step,
            status: "pending",
          }))
        );
      }
    };

    eventSource.onerror = (err) => {
      console.log("SSE reconnecting...", err);
    };

    return () => eventSource.close();
  }, [startListening]);

  const DotLoader = () => {
    return (
      <span
        style={{
          display: "inline-block",
          marginLeft: "4px",
          animation: "dotAnimation 1.4s infinite steps(3)",
        }}
      >
        ...
      </span>
    );
  };

  const thStyle = {
    textAlign: "center",
    padding: "22px 0px",
    fontWeight: 700,
    fontSize: "16px",
    border: "3px solid #e0e0e0",
  };

  const tdStyle = {
    textAlign: "center",
    padding: "22px 0px",
    fontSize: "16px",
    borderBottom: "1px solid #f0f0f0",
    border: "3px solid #e0e0e0",
  };

  return (
    <>
      <style>
        {`
@keyframes dotAnimation {
  0% { opacity: 0.2; }
  50% { opacity: 1; }
  100% { opacity: 0.2; }
}
   .kb-help-text-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.kb-help-text-btn:hover {
  background: #eef2ff;
  color: #2f80ed;
  border-color: #c7d2fe;
}
`}
      </style>

      <div className="sd-settings-branding-tab">
        <Snackbar
          open={open}
          autoHideDuration={6000}
          message={responseMessage || ""}
          onClose={() => setOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        />

        <SoftBox component="form" onSubmit={handleSubmit}>
          <Grid container spacing={3} paddingX={3} paddingBottom={4}>
            {/* ===== TITLE ===== */}
            <Grid item xs={12}>
              <SoftTypography variant="h5">White Label Domain Setup</SoftTypography>
            </Grid>

            <Grid item xs={9}>
              <FormField
                label="Enter your Domain"
                name="domain"
                disabled={agencyDomain}
                defaultValue={cleanDomain}
                onChange={(e) => {
                  setDomain(e.target.value);
                  setdomainUpdate(true);
                }}
              />
            </Grid>

            <Grid item xs={3} display="flex" alignItems="flex-end">
              {agencyDomain ? (
                <PrimaryButton
                  type="button"
                  className="sd-primary-btn--dark"
                  disabled={domainLoading}
                  onClick={Disconnect}
                  style={{ opacity: domainLoading ? 0.6 : 1 }}
                >
                  {domainLoading ? "Loading… Please Wait" : "Disconnect"}
                </PrimaryButton>
              ) : domainReconnectError ? (
                <PrimaryButton
                  type="submit"
                  disabled={domainLoading}
                  style={{ opacity: domainLoading ? 0.6 : 1 }}
                >
                  {domainLoading ? "Loading… Please Wait" : domainText}
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  disabled={domainLoading}
                  style={{ opacity: domainLoading ? 0.6 : 1 }}
                >
                  {domainLoading ? "Loading… Please Wait" : "Connect"}
                </PrimaryButton>
              )}
            </Grid>
            <Grid item xs={12}>
              {domainMessage && <span style={{ color: "green" }}>{domainMessage}</span>}
              {domainErrorMessage && <span style={{ color: "red" }}>{domainErrorMessage}</span>}
              {domainReconnectError && <span style={{ color: "red" }}>{domainReconnectError}</span>}
              {domainMessageDisconnect && (
                <span style={{ color: "green" }}>{domainMessageDisconnect}</span>
              )}
            </Grid>
            {dnsShow && (
              <Grid item xs={12}>
                <SoftBox
                  sx={{
                    overflow: "hidden",
                    background: "#fff",
                  }}
                >
                  {/* Header */}
                  <SoftBox>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                      <SoftTypography fontWeight="bold" fontSize="16px">
                        DNS Configuration
                      </SoftTypography>
                      {!loading && knowledgeBase?.domain_conf && (
                        <button
                          className="kb-help-text-btn"
                          onClick={() => window.open(knowledgeBase.domain_conf, "_blank")}
                        >
                          <FaQuestionCircle size={16} />
                        </button>
                      )}
                    </div>
                    <SoftTypography variant="caption" color="text">
                      Add the following record to your DNS configuration:
                    </SoftTypography>
                  </SoftBox>

                  {/* Table */}
                  <SoftBox component="table" width="50%" sx={{ borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#f5f5f5" }}>
                        <th style={thStyle}>Record Type</th>
                        <th style={thStyle}>Host</th>
                        <th style={thStyle}>Value</th>
                      </tr>
                    </thead>

                    <tbody>
                      {[
                        {
                          type: "CNAME",
                          host: `${subdomain}`,
                          value: "domains.easyaidirectory.com",
                        },
                      ].map((item, i) => (
                        <tr key={i}>
                          <td style={tdStyle}>{item.type}</td>
                          <td style={tdStyle}>{item.host}</td>
                          <td style={tdStyle}>{item.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </SoftBox>
                </SoftBox>
              </Grid>
            )}
            {dnsShow && subdomain === "@" && showRootFallbackDns && (
              <Grid item xs={12}>
                <SoftBox
                  sx={{
                    overflow: "hidden",
                    background: "#fff",
                  }}
                  mt={2}
                >
                  <SoftTypography variant="caption" color="text">
                    If your domain registrar does not accept a CNAME for the root domain, please add
                    the following records:
                  </SoftTypography>

                  <SoftBox component="table" width="50%" mt={1} sx={{ borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#f5f5f5" }}>
                        <th style={thStyle}>Record Type</th>
                        <th style={thStyle}>Host</th>
                        <th style={thStyle}>Value</th>
                      </tr>
                    </thead>

                    <tbody>
                      {[
                        {
                          type: "CNAME",
                          host: "www",
                          value: "domains.easyaidirectory.com",
                        },
                        {
                          type: "Redirect",
                          host: "@",
                          value: `https://www.${cleanDomain}`,
                        },
                      ].map((item, i) => (
                        <tr key={i}>
                          <td style={tdStyle}>{item.type}</td>
                          <td style={tdStyle}>{item.host}</td>
                          <td style={tdStyle}>{item.value}</td>
                        </tr>
                      ))}
                    </tbody>
                  </SoftBox>
                </SoftBox>
              </Grid>
            )}
            {dnsShow && (
              <Grid item xs={12}>
                <SoftBox mt={1}>
                  {domainSteps
                    .filter((step) => step.status !== "pending")
                    .map((step) => (
                      <SoftBox key={step.key} display="flex" alignItems="center" mb={1.5}>
                        {step.status === "completed" && (
                          <CheckCircleIcon sx={{ color: "#4caf50", fontSize: "18px" }} />
                        )}

                        <SoftTypography ml={2}>
                          {step.label}
                          {step.status === "loading" && <DotLoader />}
                        </SoftTypography>
                      </SoftBox>
                    ))}
                </SoftBox>
              </Grid>
            )}
          </Grid>
        </SoftBox>
      </div>
    </>
  );
}

export default Domain;
